import React from "react";
import { Sparkles } from "lucide-react";
import { ASSETS } from "@/lib/brand";

const steps = [
  {
    img: ASSETS.anmalPaulaBlank,
    label: "Schritt 1",
    title: "Weißes Blatt — pures Potenzial",
    text: "Jede Anmal-Paula startet weiß. 3D-gedruckt, ca. 10 cm groß.",
  },
  {
    img: ASSETS.anmalPaulaProgress,
    label: "Schritt 2",
    title: "In Kinderhand",
    text: "Mit Buntstiften und Fantasie wird Paula zur ganz persönlichen Heldin.",
  },
  {
    img: ASSETS.anmalPaulaFinished,
    label: "Schritt 3",
    title: "Fertig — ein bleibendes Andenken",
    text: "Bunt, einzigartig, von Kinderhand gemacht. Bereit für den Schreibtisch.",
  },
];

export const AnmalGallery = () => {
  return (
    <section
      id="anmal-galerie"
      data-testid="anmal-gallery-section"
      className="relative py-24 sm:py-32 bg-white border-y border-slate-200"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-3xl mb-14">
          <div className="text-xs font-semibold uppercase tracking-[0.2em] text-paula-blue mb-4">
            Die Anmal-Paula Galerie
          </div>
          <h2 className="font-display font-bold text-4xl sm:text-5xl text-paula-ink leading-[1.05] tracking-tight">
            Vom weißen Druck zur{" "}
            <span className="text-paula-red">eigenen Paula</span>.
          </h2>
          <p className="mt-6 text-paula-muted text-lg leading-relaxed">
            Jede Anmal-Paula ist ein kleines Kunstwerk. Hier siehst Du die Reise
            — vom weißen 3D-Druck bis zur fertigen, bunten Heldin.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {steps.map((s, i) => (
            <figure
              key={s.label}
              data-testid={`anmal-step-${i + 1}`}
              className="group rounded-3xl overflow-hidden bg-paula-cream border border-slate-200 flex flex-col"
            >
              <div className="relative aspect-square overflow-hidden bg-paula-cream">
                <img
                  src={s.img}
                  alt={s.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute top-4 left-4 bg-white/95 backdrop-blur px-3 py-1.5 rounded-full text-[10px] font-semibold uppercase tracking-widest text-paula-ink">
                  {s.label}
                </div>
              </div>
              <figcaption className="p-6">
                <div className="font-display font-bold text-xl text-paula-ink leading-snug">
                  {s.title}
                </div>
                <p className="text-paula-muted text-sm mt-2 leading-relaxed">
                  {s.text}
                </p>
              </figcaption>
            </figure>
          ))}
        </div>

        <div className="mt-10 inline-flex items-center gap-3 px-5 py-3 rounded-full bg-paula-yellow-soft border border-paula-yellow/40 text-sm">
          <Sparkles size={16} className="text-paula-yellow" />
          <span className="text-paula-ink">
            <span className="font-semibold">Beilage</span> in jedem Buch — eine
            eigene Anmal-Paula zum Selbermachen.
          </span>
        </div>
      </div>
    </section>
  );
};

export default AnmalGallery;
